import './App.css';
import React from 'react';
import { Link } from "react-router-dom";

class Home extends React.Component {
	render() {
		return (
			<div>
				<p>More Info Soon!</p>
			</div>
		);
	}

}

export default Home;
